import React, { useState } from 'react';
import {
  AppBar,
  Box,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Container,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

const sections = ['Inicio', 'Programas', 'Aplicacion'];

const Header = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) section.scrollIntoView({ behavior: 'smooth' });
    setDrawerOpen(false);
  };

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        backgroundColor: 'transparent',
        pt: 2,
        ...(isMobile && { position: 'relative' }), // <-- solución real aquí
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            backgroundColor: '#ffffff',
            borderRadius: '24px',
            padding: '0.8rem 1.5rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            border: '1px solid #bbb', // bordes visibles
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.35)', // sombra más intensa
          }}
        >
          <Box sx={{ fontWeight: 'bold', color: '#15A67D', fontSize: '1.2rem' }}>
            Radio Chukuta Comunicaciones
          </Box>

          {isMobile ? (
            <>
              <IconButton onClick={() => setDrawerOpen(true)} color="inherit">
                <MenuIcon sx={{ color: '#15A67D' }} />
              </IconButton>

              <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
                PaperProps={{
                  sx: {
                    borderTopLeftRadius: '16px',
                    borderBottomLeftRadius: '16px',
                    width: 250,
                    padding: 2,
                    backgroundColor: '#ffffff',
                  },
                }}
              >
                <List>
                  {sections.map((section) => (
                    <ListItem
                      key={section}
                      button
                      onClick={() => scrollToSection(section.toLowerCase())}
                      sx={{ paddingY: 1 }}
                    >
                      <ListItemText
                        primary={section}
                        primaryTypographyProps={{
                          fontWeight: 'bold',
                          color: '#15A67D',
                        }}
                      />
                    </ListItem>
                  ))}
                  <ListItem
                    button
                    component="a"
                    href="https://api.whatsapp.com/send?phone=59169750095&text=Me%20gustaria%20enviar%20un%20saludo%20por%20la%20radio"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ paddingY: 1 }}
                  >
                    <ListItemText
                      primary="Chat"
                      primaryTypographyProps={{
                        fontWeight: 'bold',
                        color: '#15A67D',
                      }}
                    />
                  </ListItem>
                </List>
              </Drawer>
            </>
          ) : (
            <Box sx={{ display: 'flex', gap: 2 }}>
              {sections.map((section) => (
                <Button
                  key={section}
                  onClick={() => scrollToSection(section.toLowerCase())}
                  sx={{
                    textTransform: 'none',
                    color: '#15A67D',
                    fontWeight: 'bold',
                    '&:hover': {
                      backgroundColor: '#e6f6f2',
                      borderRadius: '8px',
                    },
                  }}
                >
                  {section}
                </Button>
              ))}
              <Button
                href="https://api.whatsapp.com/send?phone=59169750095&text=Me%20gustaria%20enviar%20un%20saludo%20por%20la%20radio"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  textTransform: 'none',
                  color: '#15A67D',
                  fontWeight: 'bold',
                  '&:hover': {
                    backgroundColor: '#e6f6f2',
                    borderRadius: '8px',
                  },
                }}
              >
                Chat
              </Button>
            </Box>
          )}
        </Box>
      </Container>
    </AppBar>
  );
};

export default Header;
